import React, { createContext, useContext } from 'react';
import { Outlet, useParams } from 'react-router-dom';
import Loader from '../../common/Loader';
import { getConfiguration } from '../../data/utils/configuration';
import { getTimezoneOffset } from '../../data/utils/getTimezoneOffset';
import { parseTimelineData } from '../../data/parseTimelineData';
import { useFetch } from '../../data/fetch/useFetch';

export const TimelineContext = createContext(null);

export function useTimeline() {
    return useContext(TimelineContext);
}

export function useDateDesc() {
    const params = useParams();
    
    const timeline = useTimeline();
    const day = timeline.weekDays.find(d => d.date === params.date);
    return day.fullDesc;
}

export default function TimelineProvider() {
    const conf = getConfiguration();
    const [isLoading, isError, data] = useFetch(conf.api.getTimelinePalinsestiDelGiorno, { timezone: getTimezoneOffset() }, (data) =>
        parseTimelineData(data)
    );

    if (isLoading || isError) {
        return (
            <>
                <div></div>
                <Loader />
            </>
        );
    }

    return (
        <TimelineContext.Provider value={data}>
            <Outlet />
        </TimelineContext.Provider>
    );
}
